import React, { useRef, useState } from 'react';
import axios from 'axios';

const Contact = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [captcha, setCaptcha] = useState(generateCaptcha());
  const [bgColor, setBgColor] = useState(getRandomColor());
  const [formData, setFormData] = useState({
    title: '',
    name: '',
    email: '',
    phone: '',
    content: '',
    file: null,
    captchaInput: '',
    partnershipInquiry: false,
    recruitmentInquiry: false,
    otherInquiry: false,
  });
  const [captchaValid, setCaptchaValid] = useState(false); // 캡차 유효성 상태
  const [agreeToPrivacy, setAgreeToPrivacy] = useState(false);
  const [termsContent, setTermsContent] = useState('');
  const fileInputRef = useRef(null);

  const fetchTerms = async (type) => {
    try {
      const response = await axios.get('http://plassion.co.kr:8444/api/get/footer_terms', {
        params: { type },
      });
      setTermsContent(response.data[0].contents);
    } catch (error) {
      console.error('Error fetching terms:', error);
    }
  };

  const openModal = (type) => {
    fetchTerms(type);
    setModalOpen(true);
    document.body.style.overflow = 'hidden'; // Y축 스크롤 막기
  };

  const closeModal = () => {
    setModalOpen(false);
    document.body.style.overflow = 'auto'; // Y축 스크롤 복원
  };

  function generateCaptcha() {
    return Math.floor(100000 + Math.random() * 900000).toString(); // 6자리 랜덤 숫자 생성
  }

  function getRandomColor() {
    return `hsl(${Math.random() * 360}, 100%, 80%)`; // 랜덤 배경 색상 생성
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData({
      ...formData,
      [name]: checked,
    });
  };

  const handleFileChange = (e) => {
    setFormData({
      ...formData,
      file: e.target.files[0],
    });
  };

  const handleRefreshCaptcha = () => {
    setCaptcha(generateCaptcha()); // 새로운 캡차 생성
    setBgColor(getRandomColor()); // 새로운 배경 색상 생성
    setCaptchaValid(false); // 캡차 유효성 초기화
  };

  const handleCaptchaVerification = () => {
    if (formData.captchaInput === captcha) {
      setCaptchaValid(true); // 캡차 통과
      alert('자동등록방지 통과 완료!'); // 통과 완료 메시지
    } else {
      alert('자동등록방지 코드를 확인해 주세요.'); // 오류 메시지
      setFormData((prev) => ({
        ...prev,
        captchaInput: '', // 캡차 입력 초기화
      }));
      handleRefreshCaptcha(); // 새로운 캡차 생성
      document.getElementsByName('captchaInput')[0].focus(); // 캡차 입력 필드에 포커스
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { title, name, email, phone, content, file } = formData;

    // 모든 입력값을 검사
    if (!title) {
      alert('제목을 입력해 주세요.');
      document.getElementsByName('title')[0].focus(); // 제목 입력 필드 포커스
      return;
    }
    if (!name) {
      alert('이름을 입력해 주세요.');
      document.getElementsByName('name')[0].focus(); // 이름 입력 필드 포커스
      return;
    }
    if (!email) {
      alert('이메일을 입력해 주세요.');
      document.getElementsByName('email')[0].focus(); // 이메일 입력 필드 포커스
      return;
    }
    if (!phone) {
      alert('연락처를 입력해 주세요.');
      document.getElementsByName('phone')[0].focus(); // 연락처 입력 필드 포커스
      return;
    }
    if (!content) {
      alert('내용을 입력해 주세요.');
      document.getElementsByName('content')[0].focus(); // 내용 입력 필드 포커스
      return;
    }

    // 캡차 유효성 검사
    if (!captchaValid) {
      alert('자동등록방지 코드를 확인해 주세요.'); // 캡차 검증이 안된 경우
      return;
    }

    // 개인정보 수집 및 이용 동의 유효성 검사
    if (!agreeToPrivacy) {
      alert('개인정보 수집 및 이용에 동의해 주세요.'); // 체크박스 미체크시 메시지
      return;
    }

    const inquiries = [];
    if (formData.partnershipInquiry) inquiries.push('1');
    if (formData.recruitmentInquiry) inquiries.push('2');
    if (formData.otherInquiry) inquiries.push('3');

    const inquiriesString = inquiries.join(', ');

    try {
      const formDataToSend = new FormData();
      formDataToSend.append('title', title);
      formDataToSend.append('name', name);
      formDataToSend.append('email', email);
      formDataToSend.append('phone', phone);
      formDataToSend.append('content', content);
      formDataToSend.append('inquiries', inquiriesString);
      if (file) {
        formDataToSend.append('file', file); // 파일 추가
      }

      const response = await axios.post('http://plassion.co.kr:8444/api/post/contact_write', formDataToSend, {
        headers: {
          'Content-Type': 'multipart/form-data', // 파일 업로드를 위한 Content-Type
        },
      });
      alert('문의가 완료되었습니다.\n문의 답변은 개별연락을 확인해주세요!');

      // 폼 초기화
      setFormData({
        title: '',
        name: '',
        email: '',
        phone: '',
        content: '',
        captchaInput: '',
        partnershipInquiry: false,
        recruitmentInquiry: false,
        otherInquiry: false,
      });
      handleRefreshCaptcha();
      setAgreeToPrivacy(false);
      fileInputRef.current.value = '';
    } catch (error) {
      console.error('Error sending inquiry:', error);
      alert('문의 전송에 실패했습니다. 다시 시도해 주세요.');
    }
  };

  return (
    <div className="contact-wrap">
      <div className="content-left-box">
        <h2>Contact Us</h2>
        <p>플레이션 영업팀에 문의하여 플레이션에서 제공하는 기업지원에 대해 알아보세요.</p>
        <div className="other-question">다른 문의 방법이 필요하신가요?</div>
        <div className="other-contact">
          <div className="other-email">
            <span>이메일 문의</span> <span>plassion@naver.com</span>
          </div>
          <div className="other-tel">
            <span>전화 문의</span> <span>F. 0504-373-4873</span>
          </div>
        </div>
      </div>
      <div className="content-right-box">
        <div className="border-box">
          <form onSubmit={handleSubmit}>
            <table>
              <tbody>
                <tr>
                  <td>
                    제목<span className="concas">*</span>
                  </td>
                  <td>
                    <input
                      type="text"
                      name="title"
                      placeholder="제목을 입력하세요"
                      value={formData.title}
                      onChange={handleInputChange}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    이름<span className="concas">*</span>
                  </td>
                  <td>
                    <input
                      type="text"
                      name="name"
                      placeholder="이름을 입력하세요"
                      value={formData.name}
                      onChange={handleInputChange}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    이메일<span className="concas">*</span>
                  </td>
                  <td>
                    <input
                      type="email"
                      name="email"
                      placeholder="이메일을 입력하세요"
                      value={formData.email}
                      onChange={handleInputChange}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    연락처<span className="concas">*</span>
                  </td>
                  <td>
                    <input
                      type="text"
                      name="phone"
                      placeholder="연락처를 입력하세요 ex) 010123412xx"
                      value={formData.phone}
                      onChange={handleInputChange}
                    />
                  </td>
                </tr>
                <tr>
                  <td>구분</td>
                  <td>
                    <label className="chkk1">
                      <input
                        type="checkbox"
                        name="partnershipInquiry"
                        value="1"
                        checked={formData.partnershipInquiry}
                        onChange={handleCheckboxChange}
                      />
                      <span>개발 및 제휴문의</span>
                    </label>
                    <label className="chkk2">
                      <input
                        type="checkbox"
                        name="recruitmentInquiry"
                        value="2"
                        checked={formData.recruitmentInquiry}
                        onChange={handleCheckboxChange}
                      />
                      <span>채용문의</span>
                    </label>
                    <label className="chkk3">
                      <input
                        type="checkbox"
                        name="otherInquiry"
                        value="3"
                        checked={formData.otherInquiry}
                        onChange={handleCheckboxChange}
                      />
                      <span>기타문의</span>
                    </label>
                  </td>
                </tr>
                <tr>
                  <td>
                    내용<span className="concas">*</span>
                  </td>
                  <td>
                    <textarea
                      name="content"
                      placeholder="내용을 입력하세요(최대 200글자)"
                      value={formData.content}
                      onChange={handleInputChange}
                      maxLength={200}
                    />
                  </td>
                </tr>
                <tr>
                  <td>첨부파일</td>
                  <td>
                    <input type="file" onChange={handleFileChange} ref={fileInputRef} />
                  </td>
                </tr>
                <tr>
                  <td>
                    자동등록방지<span className="concas">*</span>
                  </td>
                  <td>
                    <div className="captcha">
                      <div
                        className="captcha-image"
                        style={{
                          backgroundImage: `url(${generateCaptchaImage(captcha, bgColor)})`,
                          backgroundColor: bgColor,
                        }}
                      />
                      <button className="refresh-btn" type="button" onClick={handleRefreshCaptcha}></button>
                      <button className="check-s-btn" type="button" onClick={handleCaptchaVerification}>
                        확인
                      </button>
                    </div>
                    <input
                      type="text"
                      name="captchaInput"
                      placeholder="자동등록방지 코드를 입력하세요"
                      value={formData.captchaInput}
                      onChange={handleInputChange}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="submit-wrap">
              <input type="checkbox" checked={agreeToPrivacy} onChange={() => setAgreeToPrivacy(!agreeToPrivacy)} />{' '}
              <span
                onClick={() => openModal(2)}
                style={{ cursor: 'pointer', textDecoration: 'underline', marginLeft: '8px' }}
              >
                개인정보 수집 및 이용
              </span>
              에 동의합니다.
              <button type="submit">문의하기</button>
            </div>
          </form>
        </div>
      </div>
      {modalOpen && <Modal contents={termsContent} onClose={closeModal} modalOpen={modalOpen} />}
    </div>
  );
};

// 모달 컴포넌트
const Modal = ({ contents, onClose, modalOpen }) => {
  return (
    <div className={`modal-overlay ${modalOpen ? 'open' : ''}`} onClick={onClose}>
      <div className={`modal-content ${modalOpen ? 'open' : ''}`} onClick={(e) => e.stopPropagation()}>
        <div className="close-btn-wrap">
          <div className="policy-img"></div>
          <button className="modal-close" onClick={onClose}>
            X
          </button>
        </div>
        <div className="modal-body" dangerouslySetInnerHTML={{ __html: contents }} />
      </div>
    </div>
  );
};

export default Contact;

const generateCaptchaImage = (captcha, bgColor) => {
  const canvas = document.createElement('canvas');
  canvas.width = 150; // 캔버스 너비
  canvas.height = 50; // 캔버스 높이
  const ctx = canvas.getContext('2d');

  // 배경색 설정
  ctx.fillStyle = bgColor;
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  // 텍스트 스타일 설정
  ctx.font = '30px Arial';
  ctx.fillStyle = 'black';
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';

  // 캡차 텍스트 그리기
  ctx.fillText(captcha, canvas.width / 2, canvas.height / 2);

  return canvas.toDataURL(); // 이미지 데이터 URL 반환
};
